import Phaser from 'phaser';

/**简单的文本toggle控件 */
export class Toggle extends Phaser.GameObjects.Container {
    private button: Phaser.GameObjects.Text;
    private value: boolean;
    private labelOn: string;
    private labelOff: string;
    private toggleCallback: (state: boolean) => void;

    constructor(scene: Phaser.Scene, x: number, y: number, labelOn: string, labelOff: string, value: boolean, toggleCallback: (state: boolean) => void) {
        super(scene, x, y);
        this.value = value;
        this.labelOn = labelOn;
        this.labelOff = labelOff;
        this.toggleCallback = toggleCallback;

        var text = this.value ? this.labelOn : this.labelOff;
        this.button = scene.add.text(0, 0, text, { font: '18px Arial', color: '#ffff00' });
        this.button.setInteractive().on('pointerdown', () => this.toggle());
        this.add(this.button);
    }

    private toggle() {
        this.value = !this.value;
        this.button.setText(this.value ? this.labelOn : this.labelOff);
        this.toggleCallback(this.value);
    }
}